import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';

import TagsView from 'src/sections/tags';

function TagsPage() {
  const { t } = useTranslation();
  return (
    <>
      <Helmet>
        <title> {t('nav.tags')} </title>
      </Helmet>
      <TagsView />
    </>
  );
}

export default TagsPage;
